import React from 'react';
import { Table, Row, Col, Button } from '@digital/ui';
import { dateTimeFormat } from '@app/helpers/dateTimeFormats';
import moment from 'moment';
import { Tooltip } from 'antd';
import { viewArquivoComprovanteCancelamento, downloadArquivoComprovanteCancelamento } from '@app/api/autorizacaoPagamento/autorizacao';

const ComprovantesCancelamentoTable = (props: any) => {
    const { arquivos } = props;
    const column = [
        {
            title: 'Arquivo',
            dataIndex: 'nome',
        },
        {
            title: 'Inclusão',
            dataIndex: 'dataInclusao',
            render: (text, record) => moment(record.dataInclusao).format(dateTimeFormat)
        },
        {
            title: 'Responsável',
            dataIndex: 'responsavel'
        },
        {
            title: 'Ações',
            render: (text, record) => (
                <>
                    {
                        (record.nome.split('.')[1] === 'pdf' ?
                            <Tooltip title="Visualizar Arquivo">
                                <Button
                                    onClick={() => {
                                        viewArquivoComprovanteCancelamento(record.id);
                                    }}
                                    icon="files-view_file"
                                    name="btnVisualizarArquivo"
                                />
                            </Tooltip>
                            :
                            <Tooltip title="Baixar Arquivo">
                                <Button
                                    onClick={() => {
                                        downloadArquivoComprovanteCancelamento(record.id, record.nome);
                                    }}
                                    icon="ui-download"
                                    name="btnBaixarArquivo"
                                />
                            </Tooltip>
                        )
                    }
                </>
            )
        }
    ];

    return (
        <>
            <Row>
                <Col>
                    <Table columns={column} dataSource={arquivos} />
                </Col>
            </Row>
        </>
    );
};
export default ComprovantesCancelamentoTable;